<template>
    <section class="follow-us d-none d-xl-block">
        <h5 class="follow-us-title">{{ $t('pages.follow.title') }}</h5>
        <p class="text-center">
            <a class="follow-us-link" href="javascript:void(0)" target="_blank">
                <i class="iconfont icon-weibo"></i>
            </a>
            <a class="follow-us-link" href="javascript:void(0)">
                <i class="iconfont icon-wechat"></i>
            </a>
        </p>
    </section>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions([
        'showWechatOverlay'
      ])
    }
  }
</script>

<style lang="scss">
    @import '~@/assets/styles/app';

    .side-menu {
        .follow-us {
            &-title {
                color: inherit;
                font-size: px2rem(16px);
                font-weight: normal;
                line-height: px2rem(60px);
                margin-bottom: 1rem;
                text-align: center;
            }

            &-link {
                color: #c7c7c7;
                margin-left: px2rem(10px);
                margin-right: px2rem(10px);

                @include hover-focus-active {
                    color: $red;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// FollowUs.vue?ad0755b6